import { render } from "./SupplierReturns.vue?vue&type=template&id=6dd40784&scoped=true"
import script from "./SupplierReturns.vue?vue&type=script&lang=js"
export * from "./SupplierReturns.vue?vue&type=script&lang=js"

import "./SupplierReturns.vue?vue&type=style&index=0&id=6dd40784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd40784"]])

export default __exports__